type ScrollOptions = {
  id: string;
  offset?: number;
  behavior?: ScrollBehavior;
};

const scrollToSection = ({ id, offset = 130, behavior = 'smooth' }: ScrollOptions) => {
  const element = document.getElementById(id);

  if (!element) {
    console.error(`No element found with id ${id}`);
    return;
  }

  const elementPosition = element.getBoundingClientRect().top;
  const viewportOffset = window.pageYOffset;
  const scrollAmount = elementPosition - viewportOffset - offset;

  window.scroll({
    top: scrollAmount,
    behavior
  });
};

export default scrollToSection;
